module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/WARRIOR_OF_THE_SOUTH_STYLE.3225fd27.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/WARRIOR_OF_THE_SOUTH_STYLE.png
// module id = 1180
// module chunks = 16